// Module
var code = "<nav class=\"navbar navbar-inverse navbar-fixed-bottom\"> <div class=\"container-fluid\" ng-transclude></div> </nav> ";
// Exports
module.exports = code;